var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanIdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1875 9.625H22.058C22.3781 9.07295 22.5625 8.43278 22.5625 7.75C22.5625 5.68225 20.8802 4 18.8125 4C17.6933 4 16.6877 4.49345 16 5.27355C15.3123 4.49345 14.3067 4 13.1875 4C11.1198 4 9.4375 5.68225 9.4375 7.75C9.43698 8.40861 9.61106 9.05558 9.94202 9.625H6.8125C5.26169 9.625 4 10.8867 4 12.4375V16.9375H5.875V25.1875C5.875 26.7383 7.13669 28 8.6875 28H23.3125C24.8633 28 26.125 26.7383 26.125 25.1875V16.9375H28V12.4375C28 10.8867 26.7383 9.625 25.1875 9.625ZM15.0625 26.125H8.6875C8.17056 26.125 7.75 25.7044 7.75 25.1875V16.9375H15.0625V26.125ZM15.0625 15.0625H5.875V12.4375C5.875 11.9206 6.29556 11.5 6.8125 11.5H15.0625V15.0625ZM15.0625 9.625H13.1875C12.1536 9.625 11.3125 8.78387 11.3125 7.75C11.3125 6.71613 12.1536 5.875 13.1875 5.875C14.2214 5.875 15.0625 6.71613 15.0625 7.75V9.625ZM16.9375 7.75C16.9375 6.71613 17.7786 5.875 18.8125 5.875C19.8464 5.875 20.6875 6.71613 20.6875 7.75C20.6875 8.78387 19.8464 9.625 18.8125 9.625H16.9375V7.75ZM24.25 25.1875C24.25 25.7044 23.8294 26.125 23.3125 26.125H16.9375V16.9375H24.25V25.1875ZM26.125 15.0625H16.9375V11.5H25.1875C25.7044 11.5 26.125 11.9206 26.125 12.4375V15.0625Z",
    fill: "#515C63",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanIdIcon);
export default __webpack_public_path__ + "static/media/planId_icon.18c0186bdcc23c01f52f351a36ccddad.svg";
export { ForwardRef as ReactComponent };